import React from 'react';
import Footer from '../components/common/Footer';
import { Outlet } from 'react-router-dom';
import { ScrollToTop } from '../components/common/ScrollToTop';
import ThemeProvider from '../components/common/ThemeProvider';
import Navbar from '../components/common/Navbar';

export const MainLayout = () => {
  return (
    <div>
      <Navbar/>
      <ThemeProvider />
      <ScrollToTop />
      <Outlet />
      <Footer />
    </div>
  );
}
